module.exports = __webpack_public_path__ + "static/media/mt0d0.e7bd7821.wav";